import EditEposSales from "./EposEdit/view/EditEposSales";
export default EditEposSales;

